import React, { useState } from "react"
import Select from "react-select"

const customStyles = {
  control: (styles, { isFocused }) => ({ 
    ...styles,  
    marginTop: '6px',
    border: isFocused ? '1px solid #E57345' : '1px solid #3E2B33', 
    borderRadius: '100px',
    fontSize: '14px',
    color: '#3E2B33',
    boxShadow: 'none',
    '&:hover': {
        border: '1px solid #E57345',
    },
    cursor: 'pointer',
    paddingLeft: '8px'
  }),
  option: (styles, { isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      fontSize: '14px',
      fontWeight: '500',
      backgroundColor: isFocused
        ? '#FFF6F2'
        : null,
      color: isSelected ? '#E57345' : '#3E2B33',
      cursor: isDisabled ? 'not-allowed' : 'pointer',
    };
  },
  dropdownIndicator: (styles, { isFocused }) => ({
    ...styles,
    color: isFocused ? '#E57345' : '#3E2B33',
  }),
  indicatorSeparator: styles => ({ display: 'none'}),
  input: styles => ({ ...styles, color: '#3E2B33' }),
  placeholder: styles => ({ color: '#898989' }),
  singleValue: styles => ({
    ...styles,
    fontWeight: '400',
    color: '#3E2B33',
  })
}

const MySelect = ({
  label,
  name,
  options,
  value,
  handleChange,
  placeholder,
  className,
}) => {
  // state
  const [isFocused, setIsFocused] = useState(false);
  // UI
  return (
    <div className="select-block">
      {label && 
        <label htmlFor={name} className={isFocused ? 'selected' : 'regular'}>
          {label}
        </label>
      }
      <Select
        label={label}
        className={className}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={selected => handleChange(selected)}
        options={options}
        styles={customStyles}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
      />
    </div>
  )
}

MySelect.defaultProps = {
  placeholder: `Select...`,
}

export default MySelect
